import { render, staticRenderFns } from "./tubiao.vue?vue&type=template&id=04401776&scoped=true&"
import script from "./tubiao.vue?vue&type=script&lang=js&"
export * from "./tubiao.vue?vue&type=script&lang=js&"
import style0 from "./tubiao.vue?vue&type=style&index=0&id=04401776&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04401776",
  null
  
)

export default component.exports